// Home's hands-free prompt hands the conversation over to the chat: the user started talking on Home, and the chat picks up
// listening without a click. The flag lives briefly in sessionStorage (the chat may mount after navigation) and an event
// reaches a chat that is already mounted.
const KEY = 'flow.voice.handoff';
const EVENT = 'flow:voice-handoff';
const MAX_AGE_MS = 2 * 60 * 1000;

export function offerVoiceHandoff() {
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch (_error) { /* storage unavailable: the user clicks once */ }
  window.dispatchEvent(new Event(EVENT));
}

/** True once if a recent offer is waiting; consuming it clears it. */
export function takeVoiceHandoff() {
  try {
    const at = Number(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return Number.isFinite(at) && at > 0 && Date.now() - at < MAX_AGE_MS;
  } catch (_error) {
    return false;
  }
}

export function onVoiceHandoff(listener) {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
